import { getLocalizedPath, type RouteId } from '@/shared/routing/routePaths'
import { type Locale, useLocaleStore } from '@/shared/store/localeStore'

/**
 * Devuelve el path localizado para un `RouteId`. Reactivo al `locale` del
 * store. Si se pasa `locale` explícito, se usa ese y se ignora el store.
 *
 * Solo cubre rutas SSG-bilingües listadas en `routePaths`. Para rutas
 * dinámicas (sessions, profile, etc.) usa `<Link to="...">` directamente.
 */
export function useLocalizedHref(routeId: RouteId, locale?: Locale): string {
  const current = useLocaleStore((s) => s.locale)
  return getLocalizedPath(routeId, locale ?? current)
}
